import React, {Component} from "react";
import {Link} from "react-router";
import "./AppSidebar.css";

class AppSidebar extends Component {

  render() {

    return (
      <div className="AppSidebar">
        <div className="home navItem">
          <Link to="/">H</Link>
        </div>
      </div>
    )
  }

}

export default AppSidebar;